var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 51,
    fill: "#F8FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3327 44V61.4067C74.3327 66.75 69.9927 71.0667 64.6493 71.0667H37.3493C32.006 71.0667 27.666 66.75 27.666 61.4067V44H74.3327Z",
    fill: "#BED6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3327 40.5933V44H27.666V40.5933C27.666 35.25 32.006 30.9333 37.3493 30.9333H64.6493C69.9927 30.9333 74.3327 35.25 74.3327 40.5933Z",
    fill: "#0E60E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 63.25H37C36.0433 63.25 35.25 62.4567 35.25 61.5C35.25 60.5433 36.0433 59.75 37 59.75H41.6667C42.6233 59.75 43.4167 60.5433 43.4167 61.5C43.4167 62.4567 42.6233 63.25 41.6667 63.25Z",
    fill: "#0E60E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8333 63.25H47.5C46.5433 63.25 45.75 62.4567 45.75 61.5C45.75 60.5433 46.5433 59.75 47.5 59.75H56.8333C57.79 59.75 58.5833 60.5433 58.5833 61.5C58.5833 62.4567 57.79 63.25 56.8333 63.25Z",
    fill: "#0E60E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadCard);
export default __webpack_public_path__ + "static/media/read-card.c486b7f39723dba669f96094084d2734.svg";
export { ForwardRef as ReactComponent };